import React, { useState } from 'react';
import Button from 'components/atoms/Button';
import AddEditLevers from 'components/molecules/PromoRecommendation/AddEditLevers';
import AddEditSpends from 'components/molecules/PromoRecommendation/AddEditSpends';
import { CustomModal } from 'CustomComponentCss';

interface props {
    showModal: boolean;
    setShowModal: Function;
    onYes: Function;
    confirmationTextFromParent?: string;
    minWidth?: string;
}

const confirmationText = 'Are you sure you want to delete this Event?';

const ConfirmEventModal: React.FC<props> = ({
    showModal,
    setShowModal,
    onYes,
    confirmationTextFromParent,
    minWidth = 'fit-content',
}) => {
    const handleOk = () => {
        setShowModal(false);
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    let Footer = () => {
        return (
            <div className="w-full flex justify-end items-center gap-2">
                <Button title={'No'} onClick={() => setShowModal(false)} style={{ padding: '0px 10px' }} />
                <Button title={'Yes'} onClick={() => onYes()} theme={'Solid'} style={{ padding: '0px 10px' }} />
            </div>
        );
    };

    return (
        <>
            <CustomModal
                centered
                title={'Delete Event'}
                open={showModal}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={Footer()}
                width={'fit-content'}
                style={{ minWidth: minWidth }}
            >
                <div className="p-4 font-xs"> {confirmationTextFromParent || confirmationText}</div>
            </CustomModal>
        </>
    );
};

export default ConfirmEventModal;
